// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PLAN_CERTIFICATE_COMPILE_ID,
} from './constants';

export function certificateCompileId(id) {
  return {
    type: PLAN_CERTIFICATE_COMPILE_ID,
    data:{id}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_CERTIFICATE_COMPILE_ID:
      return {
        ...state,
        certificateCompilesId:action.data.id
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/certificateCompileId.js